import { render, staticRenderFns } from "./NfcDeviceSetting.vue?vue&type=template&id=202fba12&scoped=true&"
import script from "./NfcDeviceSetting.vue?vue&type=script&lang=js&"
export * from "./NfcDeviceSetting.vue?vue&type=script&lang=js&"
import style0 from "./NfcDeviceSetting.vue?vue&type=style&index=0&id=202fba12&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202fba12",
  null
  
)

export default component.exports